export const vilogUrl = process.env.REACT_APP_VILOG_URL as string;
export const apiUrl = process.env.REACT_APP_API_URL as string;
export const shortDateFormat = 'yyyy-MM-dd';
export const dateFormat = 'yyyy-MM-dd p';
